import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import AddVehicleMakeIndex from "../../../../components/SidetabPages/Catalog/VehicleMake/AddVehicleMakeIndex";

const AddVehicleMake = () => {
  return (
    <>
      <AnnouncementBar />
      <AddVehicleMakeIndex />
    </>
  );
};
export default AddVehicleMake;
